import React, { useEffect } from 'react';
import './MesaPage.css';

const MesaPage: React.FC = () => {
  useEffect(() => {
    // Force the page to stay at the top
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div className="mesa-page">
      <div className="mesa-content">
        <div className="mesa-text">
          <h1 className="mesa-title">
            <a href="https://mesa-seating.vercel.app" target="_blank" rel="noopener noreferrer">mesa<svg className="mesa-title-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg></a>
          </h1>
          <p className="mesa-description">
            A 2D seating chart planner that allows users to create and export custom seating charts--you can think of it like Figma for event planning.
          </p>
        </div>
      </div>

      {/* Feature Sections */}
      <div className="mesa-features">
        <div className="mesa-feature">
          <div className="mesa-feature-text">
            <h2 className="mesa-feature-title">Upload Your Blueprint</h2>
            <p className="mesa-feature-description">
              I didn't want the focus of the site to be a CAD project where people recreated their entire event spaces. Rather, I thought it would be much simpler (and more accurate) for people to drop an image of their event space and modify that image as needed. Users can crop their blueprint and adjust the canvas to the room's dimensions.
            </p>
          </div>
          <div className="mesa-feature-image">
            <img 
              src="/mesa-blueprint.png" 
              alt="Blueprint Upload" 
              className="mesa-feature-img"
            />
          </div>
        </div>

        <div className="mesa-feature">
          <div className="mesa-feature-text">
            <h2 className="mesa-feature-title">Adding Tables</h2>
            <p className="mesa-feature-description">
              To get started with planning an event, users can add tables that are adjustable in size, capacity, and shape to their floorplan. Once added to the canvas, tables can be distributed evenly by using the smart-align feature.
            </p>
          </div>
          <div className="mesa-feature-image">
            <img 
              src="/mesa-tables.png" 
              alt="Adding Tables" 
              className="mesa-feature-img"
            />
          </div>
        </div>

        <div className="mesa-feature">
          <div className="mesa-feature-text">
            <h2 className="mesa-feature-title">Managing Guest Lists</h2>
            <p className="mesa-feature-description">
              Adding guests on mesa is simple: upload a list of people and then drag and drop them from the unseated guests chart onto the desired table or seat. Guests can then be edited or removed on the right side panel after being added.
            </p>
          </div>
          <div className="mesa-feature-image">
            <img 
              src="/mesa-guests.png" 
              alt="Managing Guest Lists" 
              className="mesa-feature-img"
            />
          </div>
        </div>

        <div className="mesa-feature">
          <div className="mesa-feature-text">
            <h2 className="mesa-feature-title">Exporting Plans</h2>
            <p className="mesa-feature-description">
              After a user is satisfied with their seating chart, they can export both the layout and the seating manifest in a PDF, ideal for venue staff, caterers, or clients.
            </p>
          </div>
          <div className="mesa-feature-image">
            <div className="mesa-pdf-viewer">
              <div className="mesa-pdf-page">
                <img 
                  src="/mesa-sample1.jpg" 
                  alt="Export Sample Page 1" 
                  className="mesa-pdf-img"
                />
              </div>
              <div className="mesa-pdf-page">
                <img 
                  src="/mesa-sample2.jpg" 
                  alt="Export Sample Page 2" 
                  className="mesa-pdf-img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MesaPage;

